export const TAG_TYPES = [
  { CODE: 0, TEXT: '题目类型标签' },
  { CODE: 1, TEXT: '职位类型标签' },
]

export const TAG_TYPE = {
  QUESTION_TAG: { CODE: 0, TEXT: '题目类型标签' },
  POSITION_TAG: { CODE: 1, TEXT: '职位类型标签' },
}
export const STATUS_OPTIONS = [
  { CODE: 0, TEXT: '草稿中' },
  { CODE: 1, TEXT: '已发布' },
  { CODE: 2, TEXT: '已下架' },
]
export const STATUS_OPTION = {
  DRAFT: { CODE: 0, TEXT: '草稿中' },
  PUBLISHED: { CODE: 1, TEXT: '已发布' },
  SHELVED: { CODE: 2, TEXT: '已下架' },
}
